import { Injectable, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { createEffect } from '@ngrx/effects';
import { combineLatest, map } from 'rxjs';

import { synchroniseTenantsCache } from './tenants.actions';
import { TenantsStore } from './tenants.store';

@Injectable()
export class TenantsEffects {
  readonly #tenantsStore = inject(TenantsStore);

  // This compatibility cache supports legacy NgRx selectors while TenantsStore remains authoritative.
  public synchroniseTenantsCache$ = createEffect(() =>
    combineLatest([
      toObservable(this.#tenantsStore.tenants),
      toObservable(this.#tenantsStore.isLoading),
      toObservable(this.#tenantsStore.error),
    ]).pipe(map(([tenants, isLoading, error]) => synchroniseTenantsCache({ tenants, isLoading, error })))
  );
}
